// extracted by mini-css-extract-plugin
export default {"file-input-fixed-postion":"DPFileInput_file-input-fixed-postion__fEYwr","max-img-width":"DPFileInput_max-img-width__QOpx2","file-item":"DPFileInput_file-item__56oAf"};